import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import Box from "../../components/Box";

function Default() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/operational/price");
  }, [navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent={["space-between", "flex-start"]}
      flex="1"
    />
  );
}

export default Default;
